const initialState = {
  collectorInfo: [
    {
      collectorName: "",
      collectorContactNumber: "",
    },
  ],
};

export const collectorInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        collectorInfo: action.payload,
      };
    default:
      return { ...state };
  }
};
